module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAGFBMVEX///8AJlTOESbKysrW3OP32dwmRm3VM0UjGcERAAAAmUlEQVR42u3dIREAIBAAwTcEwBAAEjAUIBP9BQUw7xB7CbbBxfqymDVZ25GsnJ5sYGFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYT1Zn65gLsubaxr3wpdmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/33.png
// module id = skLL
// module chunks = 1